@if (isInitialized) {
  <oe-flat-widget [title]="'GENERAL.AUTARCHY' | translate" [icon]="{name: 'oe-grid', color:'normal'}" button
    [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/autarchychart'">
    <oe-flat-widget-percentagebar [value]="autarchyValue">
    </oe-flat-widget-percentagebar>
  </oe-flat-widget>
}